module.exports = __webpack_public_path__ + "media/images/talent-reactivate-c0e995c7d4d35966d41e8261f8c2307b.svg";